import { useGenericModal } from '@neptune/shared/common-business-logic';
import { ADD_WIDGET_MODAL_NAME, AddWidgetModalData, Widget } from '@neptune/shared/widgets-domain';

export function useAddWidgetModal<T extends Widget = Widget>(modalData?: AddWidgetModalData<T>) {
  return useGenericModal<AddWidgetModalData<T>>(ADD_WIDGET_MODAL_NAME, modalData);
}
